<template>
  <BLayoutList
    :title="pageTitle"
    :create-route="createRoute"
    :skeleton="isLoadingAsyncData"
  >
    <BTableCommon
      v-model="selected"
      type="notification-banners"
      :list="list"
      :pagination="pagination"
      :ordering="filters.ordering"
      :loading="isLoading"
      :skeleton="isLoadingAsyncData"
      sortable-positions
      @change:pagination="onChangePagination"
      @change:sortable-positions="onUpdatePositions"
      @change:sort="onChangeSort"
      @action:delete="onDeleteWithRefresh"
    />
  </BLayoutList>
</template>

<script>
import { lkNotificationBannerPermissions as Permissions } from '@/helpers/enums/permission-models'
import { createListMixin } from '@/helpers/mixins/createListMixin'
import { NotificationBannerModel as Model } from './Model'
import { notificationBannersStoreModule as StoreModule } from './store'
import { NOTIFICATION_BANNERS_ROUTES as ROUTES } from './utils'

import BLayoutList from '@/components/layouts/BLayoutList.vue'
import BTableCommon from '@/components/tables/BTableCommon.vue'


const mixinOptions = { Model, StoreModule }
const listMixin = createListMixin(mixinOptions)

/** @typedef { import('@/helpers/mixins/createListMixin').ListMixin<any, StoreModule> } List */

export default {
  name: 'NotificationBannersList',
  components: {
    BLayoutList,
    BTableCommon,
  },
  mixins: [
    listMixin,
  ],
  computed: {
    createRoute() {
      const editable = this.$access(Permissions.create)
      return editable ? { name: ROUTES.CREATE } : void 0
    },
  },
}
</script>
